import script from "./MemberFacilityWageMonthlySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./MemberFacilityWageMonthlySetting.vue?vue&type=script&setup=true&lang=ts"

import "./MemberFacilityWageMonthlySetting.vue?vue&type=style&index=0&id=3909462a&lang=scss"

const __exports__ = script;

export default __exports__